

































import { Component, Mixins } from "vue-property-decorator";
import ModalComponent from "../_shared/modals/modal-component.vue";
import AppIconTextButton from "@/components/_shared/buttons/app-icon-text-button.vue";
import ProductCard from "@/components/_shared/cards/product-card.vue";
import store from "../../stores/store";
import router from "@/router/router";
import { orderApiProvider } from "@/providers/order-api-provider";

@Component({
  name: "new-order-modal",
  components: { ModalComponent, AppIconTextButton, ProductCard },
})
export default class NewOrderModal extends Mixins(ModalComponent) {
  nbProducts = 0;

  async open() {
    const response = await orderApiProvider.getOrder(
      store.getters["createOrder/getCurrentOrderId"]
    );
    if (response) {
      this.nbProducts = response.stocks.length;
      this.toggleModal(true);
    } else {
      this.onClickNew();
    }
  }

  async onClickContinue() {
    this.toggleModal(false);
    await router.push("/order/create");
  }

  async onClickNew() {
    this.toggleModal(false);
    await store.dispatch("createOrder/reset");
    await router.push("/order/create");
  }
}
